import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

/**
 * Initialized Sentry error tracking.
 */
export function initializeSentry(): void {
    Sentry.init({
        dsn: "https://ea68a81db2ac486a95f970c048809851@o22918.ingest.sentry.io/6133393",
        integrations: [
            new Integrations.BrowserTracing()
        ],
        // Set trace sample rate to 25% for performance monitoring
        tracesSampleRate: 0.25
    });
}
